// extracted by mini-css-extract-plugin
module.exports = {"bulletinItem":"Bulletin_bulletinItem_5m_Vx","bulletin":"Bulletin_bulletin_2MEHL"};